"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_lite_1 = require("mobx-react-lite");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var slate_1 = require("slate");

var slate_react_1 = require("slate-react");

var lodash_1 = require("lodash");

var SlateEditorContext_1 = require("./SlateEditorContext"); // ToDo: improve types


var withWrapper = function withWrapper(WrapperComponent) {
  return function (Component) {
    return function (_a) {
      var children = _a.children,
          rest = __rest(_a, ["children"]);

      return react_1.default.createElement(WrapperComponent, __assign({}, rest), react_1.default.createElement(Component, null, children));
    };
  };
};

var renderLeaf = function renderLeaf(props) {
  var leaf = props.leaf;
  var editorContext = SlateEditorContext_1.useSlateContext();
  var plugins = editorContext === null || editorContext === void 0 ? void 0 : editorContext.plugins;
  var renderLeaf$ = slate_react_1.DefaultLeaf;

  if (plugins !== undefined) {
    plugins.forEach(function (plugin) {
      if (plugin.renderLeaf !== undefined && leaf[plugin.type]) {
        renderLeaf$ = withWrapper(plugin.renderLeaf)(renderLeaf$);
      }
    });
  }

  return renderLeaf$(props);
};

var renderElement = function renderElement(props) {
  var element = props.element;
  var editorContext = SlateEditorContext_1.useSlateContext();
  var plugins = editorContext === null || editorContext === void 0 ? void 0 : editorContext.plugins;
  var renderElement$ = slate_react_1.DefaultElement;

  if (plugins !== undefined) {
    plugins.forEach(function (plugin) {
      if (plugin.renderElement !== undefined && element.type === plugin.type) {
        renderElement$ = plugin.renderElement;
      }
    });
  }

  return renderElement$(props);
};

var useIsEmptyEditor = function useIsEmptyEditor() {
  var editor = slate_react_1.useSlate();
  return slate_1.Editor.isEmpty(editor, editor.children[0]);
};

var useIsEditableAndEmpty = function useIsEditableAndEmpty() {
  return core_1.useEditToggle() && useIsEmptyEditor();
};
/**
 * hoc that can be applied to Editable based component
 * adds styles to slate wrapper in order to solve a placeholder problem
 * described in https://github.com/johnsonandjohnson/Bodiless-JS/issues/481
 */


var withEditableDefaultStyles = core_1.ifToggledOn(useIsEditableAndEmpty)(fclasses_1.addProps({
  style: {
    minWidth: '100px'
  }
}));
var Content = lodash_1.flow(withEditableDefaultStyles, core_1.ifEditable(fclasses_1.addProps({
  readOnly: false
})), core_1.ifReadOnly(fclasses_1.addProps({
  readOnly: true
})), fclasses_1.addProps({
  renderLeaf: renderLeaf,
  renderElement: renderElement
}), mobx_react_lite_1.observer)(slate_react_1.Editable);
exports.default = Content;